module.exports = __webpack_public_path__ + "img/vision.2450f9d8.svg";